module.exports = __webpack_public_path__ + "static/img/czy2.b52d334.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/czy2.jpg
// module id = O30D
// module chunks = 73